const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const AdminDropi = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADMIN_DROPI_REQUEST':
            return { loading: true, error: false, data: action.payload }
        case 'ADMIN_DROPI_ERROR':
            return { loading: false, error: true, data: [] };
        case 'ADMIN_DROPI_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'ADMIN_DROPI_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default AdminDropi